import PropTypes from 'prop-types';

// @ts-expect-error untyped module reference-resolvers
import { BUSINESS_UNIT } from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error untyped module reference-resolvers

// @ts-expect-error untyped module customer-data-reference-ui-components
import ReferenceName from 'customer-data-reference-ui-components/name/ReferenceName';
// @ts-expect-error untyped module customer-data-reference-ui-components
import UnknownName from 'customer-data-reference-ui-components/name/UnknownName';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { jsx as _jsx } from "react/jsx-runtime";
const BusinessUnitName = ({
  businessUnitId
}) => {
  if (businessUnitId === undefined || isNaN(businessUnitId)) {
    return /*#__PURE__*/_jsx("span", {
      children: '--'
    });
  }
  return /*#__PURE__*/_jsx(ReferenceName, {
    id: String(businessUnitId),
    referenceObjectType: BUSINESS_UNIT,
    onLoading: () => /*#__PURE__*/_jsx(SkeletonText, {}),
    onError: () => /*#__PURE__*/_jsx(UnknownName, {
      referenceObjectType: BUSINESS_UNIT
    }),
    onUnknown: () => /*#__PURE__*/_jsx("span", {
      children: '--'
    }),
    onResolved: ({
      reference
    }) => /*#__PURE__*/_jsx("span", {
      children: reference.label
    })
  });
};
BusinessUnitName.propTypes = {
  businessUnitId: PropTypes.number.isRequired
};
export default BusinessUnitName;